//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getDrugFormulaListByCategory } from '../../server/home/index'
import { mapMutations } from 'vuex'
import storage from 'storejs'

export default {
  data () {
    return {
      formulaList: []
    }
  },
  created () {
    let self = this
    self.hideLoad()
    this.getDrugFormulaListByCategory()
  },
  methods: {
    ...mapMutations(['hideLoad']),
    async getDrugFormulaListByCategory () {
      let res = await getDrugFormulaListByCategory({categoryId: this.$route.query.id})
      console.log('getDrugFormulaCategoryList_res', res)
      this.formulaList = res.list
    },
    handleItemClick (item) {
      this.$router.push({
        path: item.formulaIdName,
        query: {
          id: item.formulaUuid
        }
      })
    },
    // 跳转
    linkTo () {
      history.back()
      closeView()
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/formula.vue